$(document).on("click", "#sign-out", function(e){
  $.ajax({
    url: "/users/sign_out",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    method: "delete",
    success: () => { window.location.reload() },
    error: () => { alert('Logout gagal') }
  })
})